module.exports = __webpack_public_path__ + "static/img/img_7.80c3c88e.jpg";